


































































import Vue from 'vue'
import { Action } from 'vuex-class'
import * as firebase from 'firebase/app'
import Component from 'vue-class-component'
import { auth, config } from '../firebase'
import EventBus from '../EventBus'
import AuthError = firebase.auth.AuthError;

// eslint-disable-next-line
declare let google: any

@Component
export default class Auth extends Vue {
  to: string = this.$route.query.to as string
  from: string = this.$route.query.from as string
  isMagicLinkConfirmation = false
  email = ''
  isPrompt = false

  // eslint-disable-next-line
  @Action('setUser', { namespace: 'profile' }) setUser: any;

  mounted () {
    // show error
    firebase.auth().getRedirectResult()
    /*  .then(result => {
        if (result && result.user) {
          console.log(`track redirect result ${JSON.stringify(result)}`)
          this.$gtm.trackEvent({
            event: 'login',
            providerId: result.user?.providerId
          })
        }
      }) */
      .catch(this.displayErrorMessages)

    if (auth.currentUser) {
      this.$router.push({ path: this.to })
    }

    const urlParams = new URLSearchParams(window.location.search)
    if (urlParams.has('magiclink')) {
      // try to fetch email from local storage and signin silently
      const email = window.localStorage.getItem('emailForSignIn')
      if (email) {
        // email found, try to sign in
        if (auth.isSignInWithEmailLink(window.location.href)) {
          auth.signInWithEmailLink(email, window.location.href)
            .then(() => {
              window.localStorage.removeItem('emailForSignIn')
              this.displaySuccessfulLogin()
              // this.$gtm.trackEvent({
              //  event: 'login',
              //  providerId: 'EmailLink'
              // })
              this.$router.push({ path: this.to })
            }).catch((error) => {
              this.displayErrorMessages(error)
            })
        } else {
          // not a signinlink, just close auth component
          this.$router.push({ path: this.from })
        }
      } else {
        // if email not found (cross-device signin), ask user for email
        this.isMagicLinkConfirmation = true
      }
    } else {
      google.accounts.id.initialize({
        // eslint-disable-next-line
        client_id: config.clientId,
        // eslint-disable-next-line
        cancel_on_tap_outside: true,
        callback: (x: { credential: string }) => {
          const cred = firebase.auth.GoogleAuthProvider.credential(x.credential)
          firebase.auth().signInWithCredential(cred)
            .then(() => {
              this.displaySuccessfulLogin()
              this.$gtm.trackEvent({
                event: 'login',
                providerId: 'GoogleYolo'
              })
              this.$router.push({ path: this.to })
            })
            .catch((error) => {
              this.displayErrorMessages(error)
            })
        }
      })
      google.accounts.id.prompt((notification: {getMomentType(): string; isDisplayed(): boolean}) => {
        this.isPrompt = notification.isDisplayed()
      })
    }
  }

  validEmail (email: string): boolean {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return re.test(email)
  }

  displaySuccessfulLogin () {
    EventBus.$emit('message', { level: 'info', duration: 2000, message: 'Herzlich Willkommen!', subline: 'Erfolgreich eingeloggt!' })
  }

  displayErrorMessages (error: AuthError) {
    const errorCode = error.code
    // const errorMessage = error.message
    switch (errorCode) {
      case 'auth/expired-action-code':
        EventBus.$emit('message', { level: 'error', message: 'Fehler', subline: 'Der Link ist abgelaufen.' })
        break
      case 'auth/invalid-email':
        EventBus.$emit('message', { level: 'error', message: 'Fehler', subline: 'Die eMail Adresse entspricht nicht der eingegebenen Adresse.' })
        break
      case 'auth/user-disabled':
        EventBus.$emit('message', {
          level: 'error',
          message: 'Ungültiger Nutzer',
          subline: 'Der Nutzer wurde deaktiviert.'
        })
        break
      case 'auth/user-not-found':
        EventBus.$emit('message', {
          level: 'error',
          message: 'Nutzer unbekannt',
          subline: 'Es gibt keinen Nutzer mit diesem Login, oder es wurde gelöscht.'
        })
        break
      case 'auth/wrong-password':
        EventBus.$emit('message', {
          level: 'error',
          message: 'Das Passwort ist ungültig oder der Nutzer hat kein Passwort.'
        })
        break
      case 'auth/operation-not-allowed':
        EventBus.$emit('message', {
          level: 'error',
          message: 'Fehler',
          subline: 'Ein technischer Fehler ist aufgetreten.'
        })
        break
      case 'auth/weak-password':
        EventBus.$emit('message', {
          level: 'error',
          message: 'Schlechtes Passwort!',
          subline: 'Das Passwort ist zu einfach. Bitte wähle ein komplizierteres Passwort.'
        })
        break
        /** Thrown if authDomain configuration is not provided when calling firebase.initializeApp(). Check Firebase Console for instructions on determining and passing that field. */
        // case 'auth/auth-domain-config-required': break;

        /** Thrown if successive popup operations are triggered. Only one popup request is allowed at one time. All the popups would fail with this error except for the last one. */
      case 'auth/cancelled-popup-request':
        EventBus.$emit('message', {
          level: 'error',
          message: 'Zuviel Popups',
          subline: 'Es wurde ein anderes Fenster geöffnet. Probiere es nochmal!'
        })
        break

        /** Thrown if this operation is not supported in the environment your application is running on. "location.protocol" must be http or https. */
        // case 'auth/operation-not-supported-in-this-environment': break;

        /** Thrown if the popup was blocked by the browser, typically when this operation is triggered outside of a click handler. */
      case 'auth/popup-blocked':
        EventBus.$emit('message', {
          level: 'error',
          message: 'Das Popup wurde blockiert!',
          subline: 'Falls Du einen Adblocker verwendest, schalte ihn aus und probiere es nochmal.'
        })
        break

        /** Thrown if the popup window is closed by the user without completing the sign in to the provider. */
      case 'auth/popup-closed-by-user':
        EventBus.$emit('message', {
          level: 'error',
          message: 'Fenster wurde ohne einloggen geschlossen.',
          subline: 'Das hat wohl nicht geklappt, probiere es nochmal!'
        })
        break

        /** Thrown if the app domain is not authorized for OAuth operations for your Firebase project. Edit the list of authorized domains from the Firebase console. */
        // case 'auth/unauthorized-domain': break;

      case 'auth/invalid-action-code':
        EventBus.$emit('message', {
          level: 'error',
          message: 'Ungültig',
          subline: 'Der Link ist abgelaufen oder bereits benutzt.'
        })
        break

      case 'auth/email-already-in-use':
        auth.fetchSignInMethodsForEmail(this.email).then((result) => {
          const methods = []
          if (result.includes('password')) {
            methods.push('eMail & Passwort')
            if (error.email) this.email = error.email
          }
          if (result.includes('emailLink')) {
            methods.push('Email Link')
            if (error.email) this.email = error.email
          }
          if (result.includes('facebook.com')) {
            methods.push('Facebook')
          }
          if (result.includes('google.com')) {
            methods.push('Google')
          }
          if (result.includes('twitter.com')) {
            methods.push('Twitter')
          }
          if (methods.length > 1) {
            EventBus.$emit('message', {
              level: 'error',
              message: 'Email wird mit anderer Anmeldemethode benutzt',
              subline: 'Bitte benutze zur Anmeldung eine dieser Methoden: ' + methods.toString()
            })
          } else {
            EventBus.$emit('message', {
              level: 'error',
              message: 'Email wird mit anderer Anmeldemethode benutzt',
              subline: 'Bitte benutze zur Anmeldung ' + methods.toString()
            })
          }
        }).catch(this.displayErrorMessages)
        break
      case 'auth/account-exists-with-different-credential':
        if (error.email) {
          auth.fetchSignInMethodsForEmail(error.email).then((result) => {
            const methods = []
            if (result.includes('password')) {
              methods.push('eMail & Passwort')
              if (error.email) this.email = error.email
            }
            if (result.includes('emailLink')) {
              methods.push('Email Link')
              if (error.email) this.email = error.email
            }
            if (result.includes('facebook.com')) {
              methods.push('Facebook')
            }
            if (result.includes('google.com')) {
              methods.push('Google')
            }
            if (result.includes('twitter.com')) {
              methods.push('Twitter')
            }
            if (methods.length > 1) {
              EventBus.$emit('message', {
                level: 'error',
                message: 'Email wird mit anderer Anmeldemethode benutzt',
                subline: 'Bitte benutze zur Anmeldung eine dieser Methoden: ' + methods.toString()
              })
            } else {
              EventBus.$emit('message', {
                level: 'error',
                message: 'Email wird mit anderer Anmeldemethode benutzt',
                subline: 'Bitte benutze zur Anmeldung ' + methods.toString()
              })
            }
          }).catch(this.displayErrorMessages)
        }
        break
      default:
        EventBus.$emit('message', {
          level: 'error',
          message: 'Fehler',
          subline: 'Es ist ein unbekannter Fehler ' + errorCode + ' aufgetreten.'
        })
        break
    }
  }

  clearMessages () {
    EventBus.$emit('message-clear')
  }

  signInWithFacebook () {
    google.accounts.id.cancel()
    const provider = new firebase.auth.FacebookAuthProvider()
    auth.useDeviceLanguage()
    auth.signInWithRedirect(provider)
  }

  signInWithGoogle () {
    google.accounts.id.cancel()
    const provider = new firebase.auth.GoogleAuthProvider()
    auth.useDeviceLanguage()
    auth.signInWithRedirect(provider)
  }

  signInWithTwitter () {
    google.accounts.id.cancel()
    const provider = new firebase.auth.TwitterAuthProvider()
    auth.useDeviceLanguage()
    auth.signInWithRedirect(provider)
  }

  sendMagicLink () {
    google.accounts.id.cancel()
    // check email first
    if (!this.validEmail(this.email)) {
      EventBus.$emit('message', {
        level: 'error',
        message: 'E-Mail ungültig!',
        subline: 'Bitte gebe eine gültige eMail an!'
      })
      return
    }

    // send eMail login link
    auth.sendSignInLinkToEmail(this.email, {
      url: `${window.location.href}&magiclink`,
      handleCodeInApp: true
    })
      .then(() => {
        EventBus.$emit('message', {
          level: 'info',
          message: 'E-Mail prüfen!',
          subline: 'Es wurde ein Login-Link an ' + this.email + ' geschickt!'
        })
        window.localStorage.setItem('emailForSignIn', this.email)
      })
      .catch(this.displayErrorMessages)
  }

  confirmMagicLink () {
    // check email first
    if (!this.validEmail(this.email)) {
      EventBus.$emit('message', {
        level: 'error',
        message: 'E-Mail ungültig!',
        subline: 'Bitte gebe eine gültige eMail an!'
      })
      return
    }

    auth.signInWithEmailLink(this.email, window.location.href)
      .then(() => {
        window.localStorage.removeItem('emailForSignIn')
        this.displaySuccessfulLogin()
        // this.$gtm.trackEvent({
        //   event: 'login',
        //   providerId: 'EmailLink'
        // })
        this.isMagicLinkConfirmation = false
        this.$router.push({ path: this.to })
      }).catch((error) => {
        this.displayErrorMessages(error)
      })
  }

  close () {
    google.accounts.id.cancel()
    this.isMagicLinkConfirmation = false
    this.$router.push({ path: this.from })
  }
}
